import CrudStoreBuilder from "../common/CrudStoreBuilder";
import deskService from "@/services/salles/DeskService";

const getters = {
  getDesksByRoomId: (state) => (roomId) => {
    return state.desks.filter((desk) => desk.room.id === roomId);
  },
  getDesksByRoom: (state) => (room) => {
    return state.desks.filter((desk) => desk.room.id === room.id);
  },
  getAvailableDesksByRoom: (state) => (room) => {
    return state.desks.filter(
      (desk) => desk.room.id === room.id && desk.available
    );
  },
  getUnavailableDesksByCenter: (state) => (centerId) => {
    return state.desks.filter(
      (desk) => desk.room.centerId === centerId && !desk.available
    );
  },
  getUnavailableDesksByRoom: (state) => (roomId) => {
    return state.desks.filter(
      (desk) => desk.room.id === roomId && !desk.available
    );
  },
  getDesksByCenterId:(state) => (centerId) => {    
    return state.desks.filter((desk) => desk.room.centerId === centerId);
  },
};

const actions = {
  async loadDesk({ rootGetters }, desk) {
    const d = {
      room: rootGetters["roomModule/getRoomById"](desk.roomId),
      ...desk,
    };
    return d;
  },
};

export default new CrudStoreBuilder()
  .setName("desk")
  .setService(deskService)
  .setDependents(["room"])
  .setConverter((x) => {
    x.roomId = x.room.id;
  })
  .includeGetters(getters)
  .includeActions(actions)
  .build();
